<script lang="ts">
  import { onMount, onDestroy } from 'svelte'

  import serializeParams from './lib/utils/url'
  import validate from './lib/utils/validationRules'

  import Header from './components/Header.svelte'
  import Footer from './components/Footer.svelte'
  import Spinner from './components/Spinner.svelte'
  import Menu from './components/Menu.svelte'
  import Search from './components/Search.svelte'

  import Catalog from './catalog/Catalog.svelte'

  import { fetchMakerCategories, fetchBillCategories, fetchBills, fetchMakers } from './api'
  import { BILLS_TYPE, MAKERS_TYPE, FILTER_ALL } from './const'

  // TODO: внедрить после презентации
  // interface Catalog {
  //   [page: number]: 1,
  //   [count: number]: 1,
  //   [list: array]: [],
  //   [loading: boolean]: false,
  //   [countPerPage: number]: 12,
  //   [searchText: string]: '',
  //   [filterBy: string]: 'all',
  //   [lastDataChunk: array]: [],
  //   [type: string]: 'bills',
  // }

  let categories: array = []
  let catalog: object = {
    page: 1,
    items: [],
    loading: false,
    searchText: '',
    filterBy: FILTER_ALL,
    type: BILLS_TYPE,
    lastDataChunk: [],
    countPerPage: 0,
    internalOffset: 0,
    partnerOffset: 0,
    categories: [],
    internalOffset: 0,
    partnerOffset: 0,
  }

  $: {
    window.addEventListener('scroll', onScroll)
    window.addEventListener('resize', onScroll)
  }

  onMount(async () => {
    await loadData()
  })

  onDestroy(() => {
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
  })

  function getPayload() {
    const search = catalog.searchText
    const { id: categoryId } = catalog.filterBy

    const getParams = Object.assign(
      (validate.isNotEmptyString(search) && { search }),
      (validate.isPositiveInt(categoryId) && { categoryId }),
      ( catalog.type === BILLS_TYPE && { partnerOffset: catalog.partnerOffset }),
      { internalOffset: catalog.internalOffset },
    )

    return serializeParams(getParams)
  }

  function resetData() {
    catalog.items = []
    catalog.internalOffset = 0
    catalog.partnerOffset = 0
  }

  function resetFilters() {
    catalog.searchText = ''
    catalog.filterBy = FILTER_ALL
  }

  async function loadData() {
    catalog.loading = true

    if (catalog.type === BILLS_TYPE) {
      await loadBills()
    } else {
      await loadMakers()
    }

    catalog.loading = false
  }

  async function loadBills() {
    const payload = getPayload()
    const bills = await fetchBills(payload)
    const categories = await fetchBillCategories()

    catalog.items.push(...bills.result)
    catalog.lastDataChunk = bills.result
    catalog.countPerPage = bills.countPerPage
    catalog.internalOffset = bills.internalOffset
    catalog.partnerOffset = bills.partnerOffset
    catalog.categories = categories
  }

  async function loadMakers() {
    const payload = getPayload()
    const makers = await fetchMakers(payload)
    const categories = await fetchMakerCategories()

    catalog.items.push(...makers.result)
    catalog.lastDataChunk = makers.result
    catalog.countPerPage = makers.countPerPage
    catalog.internalOffset = makers.internalOffset
    catalog.categories = categories
  }

  async function onChangeTab(event: CustomEvent) {
    resetData()
    resetFilters()

    const tabCode = event.detail
    catalog.type = tabCode

    await loadData()
  }

  async function onSearch(event: CustomEvent) {
    resetData()

    const searchPhrase = event.detail
    catalog.searchText = searchPhrase

    await loadData()
  }

  async function onFilter(event: CustomEvent) {
    resetData()

    const filterData = event.detail
    catalog.filterBy = filterData

    await loadData()
  }

  async function onScroll(event: CustomEvent) {
    if (catalog.loading) {
      return
    }

    if (catalog.lastDataChunk.length < catalog.countPerPage) {
      return;
    }

    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0
    const offset = scrollTop + window.innerHeight + 20
    const height = document.documentElement.offsetHeight

    if (offset >= height) {
      await loadData()
    }
  }
</script>

<main on:scroll={onScroll}>
  <div class="container">
    <Header activeTab={catalog.type} on:changeTab={onChangeTab} />

    <div class="toolbar-container">
      <Menu activeFilter={catalog.filterBy} categories={catalog.categories} on:filter={onFilter} />
      <Search searchText={catalog.searchText} on:search={onSearch} />
    </div>

    {#if catalog.type === BILLS_TYPE}
      <Catalog items={catalog.items} type={catalog.type} />
    {/if}

    {#if catalog.type === MAKERS_TYPE}
      <Catalog items={catalog.items} type={catalog.type} />
    {/if}

    {#if catalog.loading}
      <Spinner />
    {/if}

    <Footer />
  </div>
</main>

<style>
  main {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    font-family: Montserrat;
    background-color: #ececec;
    overflow: hidden;
  }

  main:after {
    content: '';
    width: 326px;
    height: 240px;
    position: absolute;
    top: -84px;
    left: 50%;
    margin-left: 140px;
    background-image: url(/svg/header-decoration.svg);
    background-position: 0;
    background-repeat: no-repeat;
  }

  .container {
    width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .toolbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
  }

  @media screen and (min-width: 32rem) {
    .container {
      max-width: 500px;
    }
  }

  @media screen and (min-width: 481px) {
    .container {
      max-width: 740px;
    }

    .toolbar-container {
      margin-bottom: 45px;
    }
  }
</style>
